module.exports = __webpack_public_path__ + "img/extratoy.c8a3cd58.png";